import { createContext, useEffect, useState, useContext } from "react";

import { fetchInternalApi } from "../utils/apiCalls";
import { useAuth } from "../firebase";
import { useSubscriptionType } from "../hooks/companyData";

const ProductsEmissionsFactorsContext = createContext();

const emptyFactors = {
  materials: [],
  packaging: [],
  electricity: [],
  battery: [],
  electronic: [],
  transports: [],
  end_of_life: []
};

export const ProductsEmissionsFactorsContextProvider = ({ children }) => {
  const [user] = useAuth();
  const [emissionsFactors, setEmissionsFactors] = useState(emptyFactors);
  const [loading, setLoading] = useState(true);
  const [subscription] = useSubscriptionType("productCarbonFootprinting");
  const { status } = subscription || {};

  useEffect(() => {
    const fetchAndSetEmissionsFactors = async () => {
      try {
        const result = await fetchInternalApi({
          endpoint: "productEmissionsFactors",
          method: "GET",
          user
        });

        setEmissionsFactors(result?.error ? emptyFactors : result);
      } catch (e) {
        setEmissionsFactors(emptyFactors);
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      fetchAndSetEmissionsFactors();
    }
  }, [user]);

  return (
    <ProductsEmissionsFactorsContext.Provider
      value={[
        { emissionsFactors, subscription, isSubscribed: status === "active" },
        loading
      ]}
    >
      {children}
    </ProductsEmissionsFactorsContext.Provider>
  );
};

const useProductsEmissionsFactors = () =>
  useContext(ProductsEmissionsFactorsContext);
export default useProductsEmissionsFactors;
